import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=19cb8100"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=19cb8100&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports